import * as vp from 'vopay';

import { createContext } from 'react';

export type PartnerAccountContext = {
  balances: vp.AccountBalance[];
  details: vp.AccountDetailsMap;
  hasPendingAccountCreationData: boolean;
  permissions: vp.AccountPermissionsMap;
  transactions: vp.AccountTransactionsMap;
  setHasPendingAccountCreationData: (hasData: boolean) => void;
  setShouldFetchData: (shouldFetch: boolean) => void;
};

const AccountsContext = createContext<PartnerAccountContext>({
  balances: [],
  details: {},
  hasPendingAccountCreationData: false,
  permissions: {},
  transactions: {},
  setHasPendingAccountCreationData: () => {},
  setShouldFetchData: () => {},
});

export default AccountsContext;
